module.exports = __webpack_public_path__ + "static/gm-8-56307dd30b2e40e8ff1316bfa030d4cc.jpg";